// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__qCVQb","footer":"ModalUpdate_footer__2ML0z"};